import React from 'react';
import { motion } from 'framer-motion';
import { Target, Landmark, Network } from 'lucide-react';
export function HumanOpportunity() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 bg-teal-pale border-y border-line/50" data-id="element-904" data-mp="kn778u1uzl4v">
      <div className="max-w-7xl mx-auto" data-id="element-905" data-mp="zblh3oxp09ux">
        <div className="max-w-3xl mb-16" data-id="element-906" data-mp="udjwgzkmc2hc">
          <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-907" data-mp="udset6zifzzx">
            Human Opportunity and Development
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark mb-6" data-id="element-908" data-mp="1p4kklwsa0a8">
            Every weakness should be paired with a pathway
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-909" data-mp="gjixq5to2fgz">
            NCJI is designed not only to identify limitations, but to translate
            them into development pathways, support structures, and opportunity
            expansion. The system should not stop at "not ready." It should show
            what readiness requires and how it can be built.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-910" data-mp="1djkz7oby3mnt">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white p-8 rounded-lg border border-line shadow-sm" data-id="element-911" data-mp="1ieqmorkzx9e0">
            <div className="flex items-center gap-4 mb-4" data-id="element-912" data-mp="znpqgbb9fry5">
              <div className="text-teal" data-id="element-913" data-mp="13q45slfq09ko">
                <Target size={24} strokeWidth={1.5} data-id="element-914" data-mp="18idsztpgavj9" />
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark" data-id="element-915" data-mp="18joxxwumu9by">
                Self-Directed Improvement
              </h3>
            </div>
            <p className="text-ink-muted" data-id="element-916" data-mp="g1b74h7prnmd">
              Tools, learning pathways, and structured action steps for
              individual growth.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white p-8 rounded-lg border border-line shadow-sm" data-id="element-917" data-mp="1ecvz25lv70ka">
            <div className="flex items-center gap-4 mb-4" data-id="element-918" data-mp="vhe5ny30unbs">
              <div className="text-navy-light" data-id="element-919" data-mp="19flx5qhagwfk">
                <Landmark size={24} strokeWidth={1.5} data-id="element-920" data-mp="15d8vbd5nxio2" />
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark" data-id="element-921" data-mp="15fbtwlkvsk4e">
                Institutional Support
              </h3>
            </div>
            <p className="text-ink-muted" data-id="element-922" data-mp="2gt5udu77tiz0">
              Schools, employers, mentors, and development systems providing
              structured guidance.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white p-8 rounded-lg border border-line shadow-sm" data-id="element-923" data-mp="2tbrqm86leoqn">
            <div className="flex items-center gap-4 mb-4" data-id="element-924" data-mp="3c3c92hd0hgqc">
              <div className="text-navy" data-id="element-925" data-mp="2xbtqcbsrp83a">
                <Network size={24} strokeWidth={1.5} data-id="element-926" data-mp="32bol4qfnyhtm" />
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark" data-id="element-927" data-mp="329v90vma75e8">
                Community & Public Support
              </h3>
            </div>
            <p className="text-ink-muted" data-id="element-928" data-mp="3us8zga5afp3a">
              Programs, networks, and broader opportunity infrastructure scaling
              capability.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}